import sileo from 'sileo';
const EmploymentsExitInterview = new sileo.Model('hqzen', 'employment-exit-interviews');
const ExitInterviewSummary = new sileo.Model('hqzen', 'exit-interviews-summary');
const SeparationYear = new sileo.Model('hqzen', 'separation-year');
const EmployeeDepartment = new sileo.Model('hqzen', 'employee-departments');
const EmployeeTeam = new sileo.Model('hqzen', 'employee-teams');
const EmployeeCompany = new sileo.Model('hqzen', 'employee-companies');
const ExitInterview = new sileo.Model('hqzen', 'exit-interviews-answer');
const ExitInterviewDetails = new sileo.Model('hqzen', 'exit-interview-details');
const ExitInterviewList = new sileo.Model('hqzen', 'answered-exit-interview-list');
const actions = {

    fetchEmployeeCompanies(context, filters) {
        return EmployeeCompany.objects.filter(filters);
    },

    fetchEmployeeDepartments(context, filters) {
        return EmployeeDepartment.objects.filter(filters);
    },

    fetchEmployeeTeams(context, filters) {
        return EmployeeTeam.objects.filter(filters);
    },

    fetchSeparationYear(context, filters) {
        return SeparationYear.objects.filter(filters);
    },

    fetchExitInterviewSummary(context, filters) {
        return ExitInterviewSummary.objects.filter(filters);
    },

    fetchEmploymentsExitInterview(context, filters) {
        return EmploymentsExitInterview.objects.filter(filters);
    },

    fetchExitInterviewModal(context, filters) {
        return ExitInterview.objects.filter(filters);
    },

    updateEmploymentExitInterview(context, data) {
        return ExitInterviewDetails.objects.update({ pk: data.pk }, data);
    },

    fetchExitInterviewList(context, filters) {
        return ExitInterviewList.objects.filter(filters);
    },

    async getExitInterviewDetails(context, pk) {
        return await ExitInterviewDetails.objects.get(pk);
    }
};

export default {
    namespaced: true,
    actions
};
